import { ChevronUp, ChevronDown } from "lucide-react";

interface TableSortingIconProps {
  sortDirection?: "asc" | "desc" | false;
}

const TableSortingIcon = ({ sortDirection }: TableSortingIconProps) => {
  // No sorting - show both chevrons with muted colors
  if (sortDirection === false || sortDirection === undefined) {
    return (
      <div className="flex flex-col w-[10px]">
        <ChevronUp className="!h-[10px] !w-[10px] opacity-40" />
        <ChevronDown className="!h-[10px] !w-[10px] mt-[-2px] opacity-40" />
      </div>
    );
  }

  // Ascending - show only up arrow
  if (sortDirection === "asc") {
    return (
      <div className="flex flex-col w-[10px]">
        <ChevronUp className="!h-[10px] !w-[10px] text-primary" />
        <ChevronDown className="!h-[10px] !w-[10px] mt-[-2px] opacity-20" />
      </div>
    );
  }

  // Descending - show only down arrow
  if (sortDirection === "desc") {
    return (
      <div className="flex flex-col w-[10px]">
        <ChevronUp className="!h-[10px] !w-[10px] opacity-20" />
        <ChevronDown className="!h-[10px] !w-[10px] mt-[-2px] text-primary" />
      </div>
    );
  }

  return null;
};

export default TableSortingIcon;
